import { AccountBookTwoTone, WalletOutlined } from '@ant-design/icons';
import { InputNumber, Space, Typography } from 'antd';
import BigNumber from 'bignumber.js';
import React, { useEffect } from 'react';
import { NumericKeyboardInput } from '@/components/NumericKeyboard';
import PosButton from '@/components/PosButton';
import Price from '@/components/Price';
import { PointRules } from '@/models/point';
import { User } from '@/models/user';
import { playSound } from '@/utils/sound';
import styles from './style.less';
/**
 * 积分转抵扣金额
 * @param point
 * @param pointRules
 */
export const pointToAmount = (point: number, pointRules: PointRules) => {
  if (!point || !pointRules) {
    return new BigNumber(0);
  }
  return new BigNumber(point).dividedBy(pointRules.payConsumeUnit).multipliedBy(pointRules.payConsumeAmount);
};

type Props = {
  user: User;
  /**待收款总额 */
  actualPrice: BigNumber;
  totalPrice: BigNumber;
  /** 使用余额支付金额 */
  value?: BigNumber;
  onChange?: (value: BigNumber) => void;
};

const BalanceConsume: React.FC<Props> = ({ user, actualPrice, totalPrice, value, onChange }: Props) => {
  const balancePriceMaxLimit = BigNumber.min(user?.balance, totalPrice);

  useEffect(() => {
    // 如果 actualPrice 发生变化 （使用积分、优惠券），需要重新计算
    // 如果当前余额扣款超过最大限制，重新设置余额抵扣金额
    if (value && value.gt(balancePriceMaxLimit)) {
      onChange(balancePriceMaxLimit);
    }
  }, [balancePriceMaxLimit, actualPrice, value]);

  if (!user || !user.balance || totalPrice.isLessThanOrEqualTo(0)) {
    return null;
  }

  return (
    <>
      <div className={styles.balanceWrapper}>
        <div className={styles.balanceMain}>
          <h2 style={{ fontSize: 16 }}>
            <WalletOutlined /> 客户账户余额: <Price value={user.balance} />, 已使用 <Price value={value ? value : 0} />
            {/* --- 本单可结算 <Typography.Text code>{balancePriceMaxLimit.toNumber()}</Typography.Text>
            元 */}
          </h2>
          {balancePriceMaxLimit.gt(0) && (
            <div>
              <Space size={10}>
                <NumericKeyboardInput
                  value={value ? value.toNumber() : 0}
                  inputType={InputNumber}
                  onChange={v => {
                    if (!v) {
                      onChange(undefined);
                    } else {
                      if (+v > balancePriceMaxLimit.toNumber()) {
                        onChange(balancePriceMaxLimit);
                      } else {
                        onChange(new BigNumber(v));
                      }
                    }
                  }}
                  inputProps={{
                    placeholder: '请输入使用余额金额',
                    style: { width: '100%' },
                    min: 0,
                    max: balancePriceMaxLimit.toNumber(),
                    precision: 2,
                  }}
                  keyboardProps={{
                    parseValueToNumber: true,
                    precision: 2,
                    showAllClean: true,
                    placement: 'right',
                    trigger: 'click',
                    style: { width: 300 },
                  }}
                />
                <PosButton
                  onClick={() => {
                    onChange(balancePriceMaxLimit);
                    playSound('click');
                  }}>
                  全部使用
                </PosButton>
                <PosButton
                  onClick={() => {
                    onChange(undefined);
                    playSound('click');
                  }}>
                  重置
                </PosButton>
              </Space>
            </div>
          )}
        </div>
        <div>
          <h2>
            <AccountBookTwoTone twoToneColor={'#eb2f96'} /> 还需收款: <Price value={actualPrice} />
          </h2>
        </div>
      </div>
    </>
  );
};

export default BalanceConsume;
